"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Unknown = exports.USHighway = exports.StateHighway = exports.Interstate = exports.CountyRoad = void 0;
var _shieldI = _interopRequireDefault(require("./shield-i-1.png"));
var _shieldI2 = _interopRequireDefault(require("./shield-i-2.png"));
var _shieldI3 = _interopRequireDefault(require("./shield-i-3.png"));
var _shieldUsHwy = _interopRequireDefault(require("./shield-us-hwy-1.png"));
var _shieldUsHwy2 = _interopRequireDefault(require("./shield-us-hwy-2.png"));
var _shieldUsHwy3 = _interopRequireDefault(require("./shield-us-hwy-3.png"));
var _shieldStHwy = _interopRequireDefault(require("./shield-st-hwy-1.png"));
var _shieldUnkHwy = _interopRequireDefault(require("./shield-unk-hwy-1.png"));
var _shieldUnkHwy2 = _interopRequireDefault(require("./shield-unk-hwy-2.png"));
var _shieldUnkHwy3 = _interopRequireDefault(require("./shield-unk-hwy-3.png"));
var _shieldUnkHwy4 = _interopRequireDefault(require("./shield-unk-hwy-4.png"));
var _shieldCnty = _interopRequireDefault(require("./shield-cnty-1.png"));
var _shieldCnty2 = _interopRequireDefault(require("./shield-cnty-2.png"));
var _shieldCnty3 = _interopRequireDefault(require("./shield-cnty-3.png"));
var _shieldCnty4 = _interopRequireDefault(require("./shield-cnty-4.png"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var USHighway = [_shieldUsHwy.default, _shieldUsHwy.default, _shieldUsHwy2.default, _shieldUsHwy3.default];
exports.USHighway = USHighway;
var Interstate = [_shieldI.default, _shieldI.default, _shieldI2.default, _shieldI3.default];
exports.Interstate = Interstate;
var StateHighway = [_shieldStHwy.default, _shieldStHwy.default, _shieldStHwy.default, _shieldStHwy.default];
exports.StateHighway = StateHighway;
var CountyRoad = [_shieldCnty.default, _shieldCnty.default, _shieldCnty2.default, _shieldCnty3.default, _shieldCnty4.default];
exports.CountyRoad = CountyRoad;
var Unknown = [_shieldUnkHwy.default, _shieldUnkHwy.default, _shieldUnkHwy2.default, _shieldUnkHwy3.default, _shieldUnkHwy4.default];
exports.Unknown = Unknown;